module.exports = __webpack_public_path__ + "static/media/logowanie-web-swieta.5f5c0172.png";